import es from './es'
import en from './en'

const messages = {
  es,
  en
}

export default messages
